import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideBell, lucideBuilding2, lucideHeart } from '@ng-icons/lucide';

import { ZardButtonComponent } from '../../../shared/components/button';
import { ZardCardComponent } from '../../../shared/components/card';
import { UserService } from '../../../core/auth/services/user.service';
import { AppStateService } from '../../../core/services/app-state.service';

@Component({
  selector: 'app-welcome-screen',
  standalone: true,
  imports: [NgIcon, ZardButtonComponent, ZardCardComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [provideIcons({ lucideBuilding2, lucideHeart, lucideBell })],
  templateUrl: './welcome-screen.component.html',
  styleUrl: './welcome-screen.component.css',
})
export class WelcomeScreenComponent {
  protected readonly userService = inject(UserService);
  protected readonly state = inject(AppStateService);
  protected readonly router = inject(Router);

  readonly showSkip = signal(true);
  readonly showBack = signal(true);

  protected handleSkip(): void {
    const user = this.userService.getCurrentUserSync();
    this.state.authenticate('owner', user?.name || '', user?.email || '', false);
    this.router.navigate(['/']);
  }
}
